module.exports = require("clean-css");